__turbopack_context__.v({
  "className": "CLYfTW_className",
  "variable": "CLYfTW_variable",
});
